// extracted by mini-css-extract-plugin
export default {"bottomNav":"BottomNav_bottomNav__PhEPC","logo":"BottomNav_logo__NbeiO","navButton":"BottomNav_navButton__etv1W"};